export default __webpack_public_path__ + "static/washer_w.fc506510a3ba05e96c5fff5e4dc3a1cc.png";